module.exports = __webpack_public_path__ + "static/media/34-14.28b8764e.mp3";